import { render, staticRenderFns } from "./nilailine.vue?vue&type=template&id=724145d0"
import script from "./nilailine.vue?vue&type=script&lang=js"
export * from "./nilailine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports